module.exports = __webpack_public_path__ + "img/tempered_glass.9d253d8f.jpg";